import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';

import JarvisWidget from '../../../components/widgets/JarvisWidget';

import { Line } from 'react-chartjs-2';

export default class LiveFeeds extends React.Component {
  constructor() {
    super();

    this.state = {
      processed: false,
      count: 0,
      forReviewCount: 0,
      forFollowUpCount: 0,
      mskCount: 0,
      diabetesCount: 0,
      protocolFlagsCount: 0,

      history: [],
      forReviewHistory: [],
      forFollowUpHistory: [],
      mskHistory: [],
      diabetesHistory: [],
      protocolFlagsHistory: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      const { data } = nextProps;
      if (data) {
        const count = data.visitNoteCount;
        const forReviewCount = data.visitNoteForReviewCount;
        const forFollowUpCount = data.visitNoteForFollowUpCount;
        const mskCount = data.visitNoteMskCount;
        const diabetesCount = data.visitNoteDiabetesCount;
        const protocolFlagsCount = data.visitNoteProtocolFlagsCount;

        const history = this.getChartData(
          data.visitNoteHistory ? data.visitNoteHistory : [],
          'Visits',
        );
        const forReviewHistory = this.getChartData(
          data.visitNoteForReviewHistory ? data.visitNoteForReviewHistory : [],
          'For Review',
        );
        const forFollowUpHistory = this.getChartData(
          data.visitNoteForFollowUpHistory
            ? data.visitNoteForFollowUpHistory
            : [],
          'For Follow Up',
        );
        const mskHistory = this.getChartData(
          data.visitNoteMskHistory ? data.visitNoteMskHistory : [],
          'MSK',
        );
        const diabetesHistory = this.getChartData(
          data.visitNoteDiabetesHistory ? data.visitNoteDiabetesHistory : [],
          'Diabetes',
        );
        const protocolFlagsHistory = this.getChartData(
          data.visitNoteProtocolFlagsHistory
            ? data.visitNoteProtocolFlagsHistory
            : [],
          'Protocol Flags',
        );

        this.setState({
          processed: true,
          count,
          forReviewCount,
          forFollowUpCount,
          mskCount,
          diabetesCount,
          protocolFlagsCount,
          history,
          forReviewHistory,
          forFollowUpHistory,
          mskHistory,
          diabetesHistory,
          protocolFlagsHistory,
        });
      }
    }
  }

  getChartData = (history, label = '') => {
    const labels = [];
    const data = [];
    const datasets = [];

    const dayOfYear = moment().dayOfYear();

    const sorted = history.sort((a,b) => (a.doy > b.doy) ? 1 : ((b.doy > a.doy) ? -1 : 0));

    sorted.forEach(el => {
      let elDayOfYear = moment().dayOfYear(el.doy);
      if (elDayOfYear > dayOfYear) {
        elDayOfYear = moment()
          .subtract(1, 'year')
          .dayOfYear(el.doy);
      }
      labels.push(elDayOfYear.format('MM/DD'));
      data.push(el.data);
    });

    datasets.push({
      label,
      data,
      backgroundColor: 'rgba(75,192,192,0.4)',
      fill: false,
    });

    return {
      labels,
      datasets,
    };
  };

  render() {
    const { isLoading } = this.props;

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: value => {
                if (Number.isInteger(value)) {
                  return value;
                }
              },
            },
          },
        ],
      },
    };
    const legend = { position: 'none' };

    return (
      <div className="row">
        <div className="col-md-8">
          <JarvisWidget
            togglebutton={false}
            editbutton={false}
            fullscreenbutton={true}
            colorbutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                <i className="fa fa-bar-chart-o" />{' '}
              </span>
              <h2>Clinic Activity Charts </h2>
              <ul
                className="hidden-mobile hidden-tablet nav nav-tabs pull-right in hide"
                id="myTab"
              >
                <li className="active">
                  <a data-toggle="tab" href="#s1">
                    <span className="hidden-mobile hidden-tablet">Visits</span>
                  </a>
                </li>
                <li>
                  <a data-toggle="tab" href="#s2">
                    <span className="hidden-mobile hidden-tablet">
                      For Review
                    </span>
                  </a>
                </li>
                <li>
                  <a data-toggle="tab" href="#s3">
                    <span className="hidden-mobile hidden-tablet">
                      For Follow-Up
                    </span>
                  </a>
                </li>
                <li>
                  <a data-toggle="tab" href="#s4">
                    <span className="hidden-mobile hidden-tablet">
                      Protocol Flags
                    </span>
                  </a>
                </li>
                <li>
                  <a data-toggle="tab" href="#s5">
                    <span className="hidden-mobile hidden-tablet">
                      MSK Flags
                    </span>
                  </a>
                </li>
                <li>
                  <a data-toggle="tab" href="#s6">
                    <span className="hidden-mobile hidden-tablet">
                      Diabetes Flags
                    </span>
                  </a>
                </li>
              </ul>
            </header>
            <div>
              <div className="widget-body">
                {isLoading && <div className="spinner-wrap"><div className="spinner" /></div>}
                <ul
                  className="nav nav-tabs charts-tabs-nav"
                  id="activity-stats-tabs"
                >
                  <li className="active">
                    <a data-toggle="tab" href="#s1">
                      <span>Visits</span>
                    </a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#s2">
                      <span>For Review</span>
                    </a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#s3">
                      <span>For Follow-Up</span>
                    </a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#s4">
                      <span>Protocol Flags</span>
                    </a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#s5">
                      <span>MSK Flags</span>
                    </a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#s6">
                      <span>Diabetes Flags</span>
                    </a>
                  </li>
                </ul>
                {this.state.processed && (
                  <div id="charts-tab-content" className="tab-content">
                    <div className="trending-chart tab-pane active" id="s1">
                      <Line
                        data={this.state.history}
                        options={options}
                        legend={legend}
                      />
                    </div>
                    <div className="trending-chart tab-pane fade" id="s2">
                      <Line
                        data={this.state.forReviewHistory}
                        options={options}
                        legend={legend}
                      />
                    </div>
                    <div className="trending-chart tab-pane fade" id="s3">
                      <Line
                        data={this.state.forFollowUpHistory}
                        options={options}
                        legend={legend}
                      />
                    </div>
                    <div className="trending-chart tab-pane fade" id="s4">
                      <Line
                        data={this.state.protocolFlagsHistory}
                        options={options}
                        legend={legend}
                      />
                    </div>
                    <div className="trending-chart tab-pane fade" id="s5">
                      <Line
                        data={this.state.mskHistory}
                        options={options}
                        legend={legend}
                      />
                    </div>
                    <div className="trending-chart tab-pane fade" id="s6">
                      <Line
                        data={this.state.diabetesHistory}
                        options={options}
                        legend={legend}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </JarvisWidget>
        </div>
        <div className="col-md-4">
          <JarvisWidget
            togglebutton={false}
            editbutton={false}
            fullscreenbutton={false}
            colorbutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                <i className="glyphicon glyphicon-stats txt-color-darken" />{' '}
              </span>
              <h2>Clinic Activity Stats</h2>
            </header>
            <div>
              <div className="widget-body">
                {isLoading && <div className="spinner-wrap"><div className="spinner" /></div>}
                <div className="clinics-today-stats">
                  <ul className="list-group">
                    <li className="list-group-item">
                      <Link to="/clinic-activity/all/">
                        <span className="label label-info pull-right">
                          {this.state.count.toLocaleString()}
                        </span>
                        Total Visit Notes
                      </Link>
                    </li>
                    <li className="list-group-item">
                      <Link to="/clinic-activity/chart-review/">
                        <span className="label label-info pull-right">
                          {this.state.forReviewCount.toLocaleString()}
                        </span>
                        Total Visits Selected for Review
                      </Link>
                    </li>
                    <li className="list-group-item">
                      <Link to="/clinic-activity/follow-up/">
                        <span className="label label-info pull-right">
                          {this.state.forFollowUpCount.toLocaleString()}
                        </span>
                        Total Visits Selected for Follow-Up
                      </Link>
                    </li>
                    <li className="list-group-item">
                      <Link to="/clinic-activity/protocol-flags/">
                        <span className="label label-info pull-right">
                          {this.state.protocolFlagsCount.toLocaleString()}
                        </span>
                        Total Visits with Protocol Flags
                      </Link>
                    </li>
                    <li className="list-group-item">
                      <Link to="/clinic-activity/protocol-flags/?filter=msk">
                        <span className="label label-info pull-right">
                          {this.state.mskCount.toLocaleString()}
                        </span>
                        Total Visits with MSK Flags
                      </Link>
                    </li>
                    <li className="list-group-item">
                      <Link to="/clinic-activity/protocol-flags/?filter=diabetes">
                        <span className="label label-info pull-right">
                          {this.state.diabetesCount.toLocaleString()}
                        </span>
                        Total Visits with Diabetes Flags
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </JarvisWidget>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/dashboard/components/ClinicActivityStats.js